import { Text } from '@factorialco/deprecated-design-system'
import { FinanceValueObjectsFinancialDocumentTypeEnum } from 'generated/resources/graphql'

import { mapDocumentTypeText } from 'modules/finance/lib/invoices'

interface DocumentTypeProps {
  documentType: FinanceValueObjectsFinancialDocumentTypeEnum
}

export const DocumentType = ({ documentType }: DocumentTypeProps) => {
  return <Text.Normal size="200">{mapDocumentTypeText(documentType)}</Text.Normal>
}
